import { useEffect, useRef, useState } from 'react';

import { getNetworkCurrencySymbol } from '../../../lib/smart-contract-utils';
import styles from './OptionsRange.module.css';

export interface rangeOptions {
  netOption: string;
  minVal: string;
  maxVal: string;
}
interface Props {
  tailwindWidth?: string;
  label: string;
  setRangeOptions: React.Dispatch<
    React.SetStateAction<rangeOptions | undefined>
  >;
}

export const OptionsRange: React.FC<Props> = props => {
  const [showOptions, setShowOptions] = useState('none');
  const [netOption, setNetOption] = useState<string>('bsc');
  const [minVal, setMinVal] = useState<string>('');
  const [maxVal, setMaxVal] = useState<string>('');
  const [rangeError, SetRangeError] = useState(false);
  const wrapperRef = useRef(null);

  function useOutsideAlerter(ref: { current: any }) {
    useEffect(() => {
      function handleClickOutside(event: { target: any }) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowOptions('none');
        }
      }

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  }

  useOutsideAlerter(wrapperRef);

  const toggleOptions = () => {
    if (showOptions === 'none') {
      setShowOptions('');
    } else {
      setShowOptions('none');
    }
  };

  const updateMin = (e: { target: any }) => {
    const re = /^(\d+\.?\d*)$/;
    if (
      e.target.value !== '' &&
      maxVal !== '' &&
      parseFloat(e.target.value) > parseFloat(maxVal)
    ) {
      SetRangeError(true);
    } else {
      SetRangeError(false);
    }
    if (e.target.value === '' || re.test(e.target.value)) {
      setMinVal(e.target.value);
    }
  };

  const updateMax = (e: { target: any }) => {
    const re = /^(\d+\.?\d*)$/;
    if (
      e.target.value !== '' &&
      minVal !== '' &&
      parseFloat(e.target.value) < parseFloat(minVal)
    ) {
      SetRangeError(true);
    } else {
      SetRangeError(false);
    }
    if (e.target.value === '' || re.test(e.target.value)) {
      setMaxVal(e.target.value);
    }
  };

  const resetForm = () => {
    setNetOption('bsc');
    setMinVal('');
    setMaxVal('');
    props.setRangeOptions({
      netOption: 'bsc',
      minVal: '',
      maxVal: '',
    });
    setShowOptions('none');
  };

  const submitForm = () => {
    props.setRangeOptions({
      netOption,
      minVal,
      maxVal,
    });
    setShowOptions('none');
  };

  return (
    <div
      ref={wrapperRef}
      className={`${props.tailwindWidth} flex flex-col relative`}
    >
      <span className={styles.label + ' mb-2 ml-1 text-sm font-light'}>
        {props.label}
      </span>
      <div
        role="menu"
        tabIndex={0}
        aria-hidden="true"
        className={
          styles.optionsSelect +
          ' w-full h-12 flex flex-col justify-center rounded-full text-center pl-1 pr-6'
        }
        onClick={toggleOptions}
      >
        <span className="text-base">{'All Range'}</span>
      </div>
      <div
        ref={wrapperRef}
        className={`${styles.optionsEntry} w-48 absolute top-16 pl-2 pt-3 pr-6 rounded-lg mt-4 z-20`}
        style={{ display: showOptions }}
      >
        <span className="text-sm mt-4 ml-1">
          {getNetworkCurrencySymbol()} or MOGUL
        </span>
        {/* Uncomment when we can support searching by specific currency */}
        {/* <div className="flex items-center mt-1 mb-2" onChange={updatedRadio}>
          <input
            id="bscRadio"
            type="radio"
            name="net"
            value="bsc"
            checked={netOption === 'bsc'}
            onChange={() => {}}
          />
          <label htmlFor="bscRadio" className="text-xs mt-1 mr-2">
            BSC
          </label>
          <input
            id="ethRadio"
            type="radio"
            name="net"
            value="eth"
            checked={netOption === 'eth'}
            onChange={() => {}}
          />
          <label htmlFor="ethRadio" className="text-xs mt-1 mr-2">
            ETH
          </label>
          <input
            id="starsRadio"
            type="radio"
            name="net"
            value="stars"
            checked={netOption === 'stars'}
            onChange={() => {}}
          />
          <label htmlFor="starsRadio" className="text-xs mt-1">
            STARS
          </label>
        </div> */}
        <div className="flex justify-center items-center ml-3 mt-2">
          <input
            className={styles.rangeInput + ' w-20 h-8 rounded-sm'}
            value={minVal}
            onChange={updateMin}
            type="number"
            placeholder=" min"
          />
          <span className="mx-2">to</span>
          <input
            className={styles.rangeInput + ' w-20 h-8 rounded-sm'}
            value={maxVal}
            onChange={updateMax}
            type="number"
            placeholder=" max"
          />
        </div>
        {rangeError ? (
          <div className={styles.rangeError + ' text-xs mt-1'}>
            Warning: Min Value Greater Than Max Value
          </div>
        ) : null}
        <hr className={styles.divider + ' mt-3'} />
        <div className="flex justify-end items-center mb-3 text-sm">
          <button className="mr-6" onClick={resetForm}>
            reset
          </button>
          <button onClick={submitForm}>apply</button>
        </div>
      </div>
    </div>
  );
};
